<template>
    <UploadCmrPopup v-if="showPopup" @close="closePopup" />
    <tr role="row" class="top-row">
        <td colspan="100%">
            <table width="100%">
                <tr>
                    <th
                        v-if="['3', '4', '5'].includes(orderStatus ?? '')"
                        class="vehicle-checkbox"
                    ></th>
                    <th class="dashboard__table-th text-left" aria-sort="none">
                        <div class="dashboard__table-title top-row-cell padding-25">
                            <i18n-t keypath="cart.status" />
                        </div>
                    </th>
                    <th
                        class="dashboard__table-th dashboard__table-sorting text-left"
                        v-if="['2', '3', '4', '5', '6'].includes(orderStatus ?? '')"
                    ></th>

                    <th class="dashboard__table-th dashboard__table-sorting text-left">
                        <div class="dashboard__table-title top-row-cell">
                            <i18n-t keypath="cart.cars" />
                        </div>
                    </th>

                    <th
                        class="dashboard__table-th dashboard__table-sorting text-left"
                    ></th>

                    <th class="dashboard__table-th dashboard__table-sorting text-left">
                        <div
                            class="dashboard__table-title top-row-cell"
                            @click="changeAmountSortOrder"
                        >
                            <i18n-t keypath="cart.orderAmount" />
                        </div>
                    </th>

                    <th class="dashboard__table-th" aria-sort="none">
                        <div class="dashboard__table-title top-row-cell">
                            <i18n-t keypath="myOrders.actions" />
                        </div>
                    </th>
                </tr>
                <template v-if="orderVehicles.length > 0">
                    <order-vehicle-item
                        v-for="vehicle of orderVehicles"
                        :key="vehicle.id"
                        :order="order"
                        :orderVehicle="vehicle"
                        :orderStatus="orderStatus"
                        :payments="payments"
                        :sortOrder="sortOrder"
                        v-model:_selectedCars="selectedCars"
                        v-model:_isPaymentsTransactionsPopup="isPaymentsTransactionsPopup"
                        v-model:_orderPaymentDto="orderPaymentDto"
                        v-model:_orderId="orderId"
                        :fetchOrders="fetchOrders"
                    />
                </template>
                <tr v-else>
                    <td colspan="100%">
                        <div class="spinner">
                            <p-spinner strokeWidth="8" animationDuration=".8s" />
                        </div>
                    </td>
                </tr>
            </table>
        </td>
    </tr>
</template>

<script lang="ts">
import { OrderVehicleTable } from "./order-vehicle-table";
export default OrderVehicleTable;
</script>
<style scoped>
.spinner {
    display: flex;
    align-content: center;
    justify-content: center;
}
.top-row {
    border: 1px #e4eaf0 solid;
    border-right: none;
    background: rgba(228, 234, 240, 0.3);
    width: 100%;
}
.top-row-cell {
    font-size: c-rem(12);
    text-align: right;
    color: #283747;
    font-family: var(--font-family);
    font-weight: 400;
    word-wrap: break-word;
}
.padding-25 {
    padding-left: 25px;
}
</style>
